import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { signInAction, getUserAction } from '../../../redux/actions/authActions';


class LogInForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    signInAction: PropTypes.func.isRequired,
    getUserAction: PropTypes.func.isRequired,
    history: PropTypes.shape.isRequired,
  };

  constructor() {
    super();
    this.state = {
      showPassword: false,
    };
  }

  componentWillMount() {
    const user = localStorage.getItem('mm_admin');
    if (user) {
      this.props.getUserAction(user, this.props.history);
    }
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  submit = (values) => {
    console.log(values);
    this.props.signInAction(values, this.props.history);
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <form className="form" onSubmit={handleSubmit(this.submit)}>
        <div className="form__form-group">
          <span className="form__form-group-label">Username</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="email"
              component="input"
              type="text"
              placeholder="Name"
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="password"
              component="input"
              type={this.state.showPassword ? 'text' : 'password'}
              placeholder="Password"
            />
            <button
              className={`form__form-group-button${this.state.showPassword ? ' active' : ''}`}
              onClick={e => this.showPassword(e)}
            >
              <EyeIcon />
            </button>
          </div>
          <div className="account__forgot-password">
            <a href="/">Forgot a password?</a>
          </div>
        </div>
        <button type="submit" className="btn btn-primary account__btn account__btn--small">Sign In</button>
        {/* <Link className="btn btn-primary account__btn account__btn--small" to="/pages/one">Sign In</Link> */}
      </form>
    );
  }
}

function mapStateToProps(state) {
  return { errorMessage: state.auth.error };
}

const reduxFormLogin = reduxForm({
  form: 'log_in_form',
  // validate
})(LogInForm);

export default connect(mapStateToProps, { signInAction, getUserAction })(withRouter(reduxFormLogin));
